import { createStyles, TFMarkdownText } from '@tf/ui';
import type React from 'react';

const useStyles = createStyles(() => ({
	infoContainer: {
		'& > p': {
			margin: '0.25rem 0 !important',
		},
	},
}));

interface InfoFieldProps {
	label: string;
}

export const InfoField: React.FC<InfoFieldProps> = ({ label }) => {
	const { classes } = useStyles();
	return <TFMarkdownText className={classes.infoContainer} text={label} />;
};
